module.exports = __webpack_public_path__ + "static/media/lock.c076eab5.svg";